import React, { useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'
import { localized } from 'decorators'
import { prepareEnumData } from './_helpers'
import { SimpleSelect } from './_simpleSelect'

export const EnumSelect = (props) => {

  const { enum: enumeration, localize, value, nullable, onChange, isMulti, isOptionDisabled, ...otherProps } = props
  const data = useMemo(() => prepareEnumData(enumeration, localize, isOptionDisabled), [enumeration, localize, isOptionDisabled])
  const handleChange = useCallback((e) => {
    if (typeof onChange === 'function') {
      if (isMulti) {
        const values = (e && e.length > 0 ? e.map(x => x.id) : e)
        onChange(values, e)
      } else {
        const value = (e ? e.id : e)
        onChange(value, e)
      }
    }
  }, [onChange, isMulti])
  return (
    <SimpleSelect
      {...otherProps}
      nullable={nullable}
      isMulti={isMulti}
      data={data}
      value={value}
      localize={localize}
      isSearchable={false}
      loading={false}
      onChange={handleChange}
      isEnum
      isOptionDisabled={(option) => option.disabled === true}
      />
  )
}

EnumSelect.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]),
  onChange: PropTypes.func,
  enum: PropTypes.object,
  nullable: PropTypes.bool,
  isOptionDisabled: PropTypes.func
}
EnumSelect.defaultProps = {
  nullable: false
}

export default localized(EnumSelect)
